import { Tag } from "@blueprintjs/core";

import HtmlDefault from "common/fragments/HtmlDefault";
import { BlockView } from "common/views/block/BlockView.view";
import { CardVariant, CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import InlineList from "../../common/fragments/InlineList";
import { iDef, iLet } from "../../core/util/TypeUtils";
import Product from "./entities/Product";

export interface IProductFragmentProps {
	product: Product;
}

export const Banner: Fragment<IProductFragmentProps> = {
	name: "Banner",
	component: ({product}) => (
		<BlockView viewKey="banner">
			<ImageView variant={ImageVariant.BANNER} src={product.iconURL} viewKey="banner-image">
				<BlockView viewKey="banner-inner">
					<HeadingView variant={HeadingVariant.H1} viewKey="banner-title">{product.name}</HeadingView>
				</BlockView>
			</ImageView>
		</BlockView>
	)
};

export const Title: Fragment<IProductFragmentProps> = {
	name: "Product name",
	component: ({product}) => (
		<HeadingView variant={HeadingVariant.H2} viewKey={"product-title"}>{product.name}</HeadingView>
	)
};

export const Abstract: Fragment<IProductFragmentProps> = {
	name: "Product abstact",
	enabled: ({product}) => !!product.shortDescription,
	component: ({product}) => (
		<CardView variant={CardVariant.SURFACE} viewKey="product-abstract">
			<HtmlDefault html={product.shortDescription} />
		</CardView>
	)
};

export const Description: Fragment<IProductFragmentProps> = {
	name: "Product description",
	enabled: ({product}) => !!product.description,
	component: ({product}) => (
		<CardView variant={CardVariant.SURFACE} viewKey="product-description">
			<HtmlDefault html={product.description}/>
		</CardView>
	)
};

export const Tags: Fragment<IProductFragmentProps> = {
	name: "Product tags",
	component: ({product: { tags = [] }}) => (
		<CardView variant={CardVariant.SURFACE} viewKey="product-tags">
			<InlineList label={<Label k="product.tags" v="tags" />}>
				{tags && tags.map((tag) => (
					<Tag key={tag.id}>{tag.name}</Tag>
				))}
			</InlineList>
		</CardView>
	)
};

export const Credits: Fragment<IProductFragmentProps> = {
	name: "Product credits",
	enabled: () => false,
	component: ({product: { tags = [] }}) => (
		<CardView variant={CardVariant.SURFACE} viewKey="product-credits">
			<InlineList label={<Label k="product.credits" v="Credits" />}>
				{tags && tags.map((tag) => (
					<Tag key={tag.id}>{tag.name}</Tag>
				))}
			</InlineList>
		</CardView>
	)
};

export const PackageContents: Fragment<IProductFragmentProps> = {
	name: "Package contents",
	enabled: ({product}) => false,
	component: ({product}) => (
		<CardView variant={CardVariant.SURFACE} viewKey="product-children">
			Packages!
		</CardView>
	)
};



// WEBPACK FOOTER //
// ./src/panels/productDetails/productFragments.tsx